export default {
    'required': 'campo obligatorio',
    'diff_date_in_month': 'Las fechas deben tener una diferencia de no más de 12 meses',
    'diff_date_in_three_month': 'Las fechas no deben tener más de 3 meses de diferencia.',
    'task_is_timeless_at': 'Seleccione el período de creación de la tarea.'
}
